module.exports = __webpack_public_path__ + "img/Cinema 4D Essential_Silicon Stone Education_20200906.c218966e.jpg";